import React, { FC } from "react";
import { Container } from "../../../../components";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { Form, RootState } from "../../../../../../models";
import { RapidForm } from "../../../../rapidform";
import * as COMBINED_SELECTORS from "../../../state/selectors/combinedSelectors";
import { getFormById } from "../../../state/selectors/formSelectors";
import HardwareOnly from "../HardwareOnly/HardwareOnly";

interface StateProps {
    personalDetailsForm: Form;
    showHardwareFields: boolean;
}

interface PersonalDetailsFormProps extends StateProps {
    onSubmitPersonalDetails: () => void;
}

const PersonalDetailsForm: FC<PersonalDetailsFormProps> = ({
    showHardwareFields,
    personalDetailsForm,
    onSubmitPersonalDetails,
}) => {
    const form = (
        <RapidForm
            id={FORM_ID.PERSONAL_DETAILS}
            action={"#"}
            errors={personalDetailsForm.errors}
            values={personalDetailsForm.values}
            visible={personalDetailsForm.visible}
            started={personalDetailsForm.started}
            onSubmit={onSubmitPersonalDetails}
            data-di-mask
        >
            {showHardwareFields && <HardwareOnly />}
        </RapidForm>
    );

    const visualFormContentExists = showHardwareFields;

    // Form is necessary even though no fields are visible due
    // to existing customer using the same form button
    if (!visualFormContentExists) {
        return form;
    }

    return (
        <Container
            className="beta-checkout__section"
            size="small"
            whiteBg={visualFormContentExists}
            noPaddingTop
            data-cy="personal-details-form"
        >
            {form}
        </Container>
    );
};

const mapStateToProps = (state: RootState): StateProps => ({
    personalDetailsForm: getFormById(state, FORM_ID.PERSONAL_DETAILS),
    showHardwareFields: COMBINED_SELECTORS.isHardwareOnly(state),
});

export default connect(mapStateToProps)(PersonalDetailsForm);
